const titleToSlug = (title) => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

const blogsData = [
  {
    slug: titleToSlug('Why Every Business Needs Monitoring — Now More Than Ever'),
    seoTitle: 'Why Every Business Needs Monitoring in 2026 | WatchNod',
    title: 'Why Every Business Needs Monitoring — Now More Than Ever',
    author: 'Mahi Choubey',
    date: 'August 1, 2025',
    description: 'Why is monitoring critical for businesses? Learn how to prevent downtime, protect revenue, and track server & API health effectively.',
    keywords: 'business monitoring, server monitoring importance, downtime prevention, business continuity, real-time monitoring',
    contentKey: 'blog-1'
  },
  {
    slug: titleToSlug('What Happens When You Don\'t Monitor Your Nodes & Domains?'),
    seoTitle: 'What Happens When You Don\'t Monitor Your Nodes & Domains?',
    title: 'What Happens When You Don\'t Monitor Your Nodes & Domains?',
    author: 'Raja Jaimini',
    date: 'August 1, 2025',
    description: 'What happens without monitoring? Learn how downtime, domain expiry, and server failures impact your business and how to prevent costly issues early.',
    keywords: 'domain monitoring, node monitoring, uptime tracking, downtime prevention',
    contentKey: 'blog-2'
  },
  {
    slug: titleToSlug('Monitor More, Spend Less- Why WatchNod Is the Smartest Budget-Friendly Choice'),
    seoTitle: 'Affordable Monitoring Tool for Startups & SaaS',
    title: 'Monitor More, Spend Less — Why WatchNod Is the Smartest Budget-Friendly Choice',
    author: 'Mahi Choubey',
    date: 'August 1, 2025',
    description: 'Looking for affordable monitoring? Learn how WatchNod helps startups track server, API, and domain health with powerful features at budget-friendly pricing.',
    keywords: 'affordable monitoring, budget-friendly, cost-effective monitoring',
    contentKey: 'blog-3'
  },
  {
    slug: titleToSlug('How Domain Monitoring Prevents Security & SEO Nightmares'),
    seoTitle: 'How Domain Monitoring Prevents SEO & Security Risks',
    title: 'How Domain Monitoring Prevents Security & SEO Nightmares',
    author: 'Raja Jaimini',
    date: 'August 1, 2025',
    description: 'How does domain monitoring protect your business? Learn how to prevent domain expiry, SEO loss, and security risks with real-time monitoring and alerts.',
    keywords: 'domain monitoring, security, SEO, DNS, SSL monitoring',
    contentKey: 'blog-4'
  }
];

const caseStudiesData = [
  {
    slug: titleToSlug('Digital Petroleum Retail Startup Achieves 24/7 Infrastructure Visibility'),
    seoTitle: 'Infrastructure Monitoring Case Study | 24/7 Visibility with WatchNod',
    title: 'Digital Petroleum Retail Startup Achieves 24/7 Infrastructure Visibility',
    description: 'See how a startup achieved 24/7 infrastructure monitoring, prevented downtime, and improved server performance with real-time alerts and visibility.',
    keywords: 'petroleum ecommerce, infrastructure monitoring, real-time dashboards, Windows Server monitoring, IIS, MS-SQL',
    contentKey: 'caseStudy-1'
  },
  {
    slug: titleToSlug('E-Commerce Platform Survives Flash Sales Without Downtime'),
    seoTitle: 'eCommerce Monitoring Case Study | Prevent Downtime with WatchNod',
    title: 'E-Commerce Platform Survives Flash Sales Without Downtime',
    description: 'Learn how an eCommerce platform prevented downtime, handled traffic spikes, and improved checkout performance with real-time server and API monitoring.',
    keywords: 'ecommerce monitoring, flash sale, high traffic, Node.js, MongoDB, AWS, load balancing',
    contentKey: 'caseStudy-2'
  },
  {
    slug: titleToSlug('SaaS Startup Gains Early Stability with Scalable Monitoring'),
    seoTitle: 'SaaS Monitoring Case Study | Scalable Infrastructure with WatchNod',
    title: 'SaaS Startup Gains Early Stability with Scalable Monitoring',
    description: 'Learn how a SaaS startup improved stability, detected issues early, and scaled monitoring across microservices with real-time alerts and insights.',
    keywords: 'SaaS monitoring, Kubernetes, microservices, Docker, DigitalOcean, container monitoring, scaling',
    contentKey: 'caseStudy-3'
  },
  {
    slug: titleToSlug('Freelancer DevOps Engineer Offers Premium Monitoring as a Service'),
    seoTitle: 'DevOps Monitoring Case Study | Manage Multiple Clients with WatchNod',
    title: 'Freelancer DevOps Engineer Offers Premium Monitoring as a Service',
    description: 'Learn how a DevOps freelancer managed multiple clients, automated uptime monitoring, and delivered real-time server insights with a unified monitoring platform.',
    keywords: 'DevOps, freelancer, multi-tenant monitoring, uptime reporting, monitoring as a service',
    contentKey: 'caseStudy-4'
  }
];

export { blogsData, caseStudiesData };
